import React from "react";
import { styled } from "styled-components";
import { Variant, variants } from "./types";
import { RefreshIcon, WalletFilledIcon, WarningIcon } from "../../../../components/Svg";
import { Colors } from "../../../../theme/types";

const MenuIconWrapper = styled.div<{ borderColor: keyof Colors }>`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background};
  border-color: ${({ theme, borderColor }) => theme.colors[borderColor]};
  border-radius: 50%;
  border-style: solid;
  border-width: 2px;
  display: flex;
  height: 40px;
  justify-content: center;
  left: 0;
  position: absolute;
  top: -4px;
  width: 40px;
  z-index: 102;
`;

const StyledIdenticon = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  left: 0;
  top: -4px;
  z-index: 102;
  background-color: ${({ theme }) => theme.colors.background};
`;

export const NoProfileMenuIcon: React.FC<React.PropsWithChildren> = () => <WalletFilledIcon color="primary" width="20px" />;

export const PendingMenuIcon: React.FC<React.PropsWithChildren> = () => (
  <MenuIconWrapper borderColor="secondary">
    <RefreshIcon color="secondary" width="24px" spin />
  </MenuIconWrapper>
);

export const WarningMenuIcon: React.FC<React.PropsWithChildren> = () => (
  <MenuIconWrapper borderColor="warning">
    <WarningIcon color="warning" width="24px" />
  </MenuIconWrapper>
);

export const DangerMenuIcon: React.FC<React.PropsWithChildren> = () => (
  <MenuIconWrapper borderColor="failure">
    <WarningIcon color="failure" width="24px" />
  </MenuIconWrapper>
);

const MenuIcon: React.FC<React.PropsWithChildren<{
  iconRef?: React.MutableRefObject<HTMLDivElement>;
  variant: Variant
}>> = ({
  iconRef,
  variant
}) => {
  if (variant === variants.DANGER) {
    return <DangerMenuIcon />;
  }

  if (variant === variants.WARNING) {
    return <WarningMenuIcon />;
  }

  if (variant === variants.PENDING) {
    return <PendingMenuIcon />;
  }

  if (!iconRef) {
    return <NoProfileMenuIcon />;
  }

  return <StyledIdenticon><span ref={iconRef} /></StyledIdenticon>;
};

export default MenuIcon;
